'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = require('lodash');

var _AndCondition = require('../conditions/AndCondition');

var _AndCondition2 = _interopRequireDefault(_AndCondition);

var _NotCondition = require('../conditions/NotCondition');

var _NotCondition2 = _interopRequireDefault(_NotCondition);

var _QueryNodeVisitor2 = require('../engine/QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _DocumentType = require('../predicates/DocumentType');

var _DocumentType2 = _interopRequireDefault(_DocumentType);

var _DocumentTypeList = require('../predicates/DocumentTypeList');

var _DocumentTypeList2 = _interopRequireDefault(_DocumentTypeList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentTypeSecurityOptimizerVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(DocumentTypeSecurityOptimizerVisitor, _QueryNodeVisitor);

    function DocumentTypeSecurityOptimizerVisitor(queryNode) {
        (0, _classCallCheck3.default)(this, DocumentTypeSecurityOptimizerVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DocumentTypeSecurityOptimizerVisitor.__proto__ || (0, _getPrototypeOf2.default)(DocumentTypeSecurityOptimizerVisitor)).call(this));

        _this.queryNode = queryNode;
        return _this;
    }

    (0, _createClass3.default)(DocumentTypeSecurityOptimizerVisitor, [{
        key: 'visitBinderQuery',
        value: function visitBinderQuery(context) {
            var binderNode = (0, _lodash.get)(this.queryNode, context.path, this.queryNode);
            context.skipData = true;
            var _context$appContext = context.appContext,
                ignoreSecurity = _context$appContext.ignoreSecurity,
                documentTypeIds = _context$appContext.documentTypeIds;

            var rootConditions = void 0;
            if (binderNode.children.length === 1) {
                // if there is only one Conditions, assume it is the root (used by ApiDocumentQueryLoader)
                rootConditions = binderNode.children[0];
            } else {
                rootConditions = binderNode.children.filter(function (conditions) {
                    return conditions.isRootFolder;
                })[0];
            }
            var nonRootConditionsList = binderNode.children.filter(function (conditions) {
                return conditions !== rootConditions;
            });
            this.computeAllowableFolderDocumentTypes(nonRootConditionsList, ignoreSecurity, documentTypeIds);

            var isSecurityClauseNeeded = this.isSecurityClauseNeeded(rootConditions);

            // if security clause not needed, all non-root folders document type predicates can be removed
            if (!isSecurityClauseNeeded) {
                nonRootConditionsList.forEach(function (c) {
                    return binderNode.removeChild(c);
                });
            }
            if (!context.appContext.isSecurityClauseNeeded) {
                context.appContext.isSecurityClauseNeeded = {};
            }
            context.appContext.isSecurityClauseNeeded[binderNode.nodeId] = isSecurityClauseNeeded;
        }
    }, {
        key: 'computeAllowableFolderDocumentTypes',
        value: function computeAllowableFolderDocumentTypes(nonRootConditionsList, ignoreSecurity, documentTypeIds) {
            // get a list of allowable document type ids
            // non-root folder Conditions only has one DocumentTypePredicate as child
            // since the deepest nested folder's document types should only be included in the result
            // intersection of document types among non-root folders are used here instead of
            // making assumption about the order of non-root folders in the list
            // if there is only the root folder, no filtering on document types will be made
            var allowableFolderDocumentTypes = null;
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(nonRootConditionsList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var nonRootConditions = _step.value;

                    var folderDocTypeIds = nonRootConditions.children.map(function (dt) {
                        return dt.documentType.id;
                    });
                    if (!allowableFolderDocumentTypes) {
                        allowableFolderDocumentTypes = folderDocTypeIds;
                    } else {
                        allowableFolderDocumentTypes = (0, _lodash.intersection)(allowableFolderDocumentTypes, folderDocTypeIds);
                    }
                }

                // if ignoreSecurity is false, intersect the list of document types that the user
                // has access to with the allowableFolderDocumentTypes to get the final list
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            if (allowableFolderDocumentTypes != null) {
                if (ignoreSecurity) {
                    this.allowableDocumentTypes = allowableFolderDocumentTypes;
                } else {
                    this.allowableDocumentTypes = (0, _lodash.intersection)(allowableFolderDocumentTypes, documentTypeIds);
                }
            } else {
                if (ignoreSecurity) {
                    this.allowableDocumentTypes = null;
                } else {
                    this.allowableDocumentTypes = documentTypeIds;
                }
            }
        }

        // DT: Document type predicate
        // DP: Descriptor predicate

        // OR ( AND ( DT1, DP1 ), DT2 ( DP2 ) )                                             => false
        // OR ( AND ( DT1, DP1 ), DP2 )                                                     => true
        // OR ( AND ( DT1, DP1 ), NOT ( DT2 ) )                                             => true
        // OR ( AND ( DT1, DP1 ), NOT ( OR ( DT2 ) ) )                                      => true
        // OR ( AND ( NOT ( DT2 ), AND ( DT1, DP1 ) ) )                                     => false
        // OR ( AND ( NOT ( DT2 ), AND ( DT1, DP1 ) ), DP2() )                              => true
        // OR ( AND ( DT1, DP1 ), AND ( DT2, NOT ( DP2 ) ) )                                => false
        // OR ( AND ( DT1, OR ( DT2, DP1 ) ), DT3 ( DP2 ) )                                 => false
        // OR ( AND ( OR ( DT1, DP1), OR ( DT2, DP2 ) ), DT3 ( DP3 ) )                      => true
        // OR ( AND ( OR ( DT1, AND ( DT2, DP2 ) ), AND ( DT3, DP3 ) ), DT4 ( DP4 ) )       => false
        // OR ( AND ( OR ( DT1 ), OR ( DT2 ) ), DT3 ( DP3 ) )                               => false
        // OR ( OR ( AND ( DT1, DP1 ), AND( DT2, DP2 ) ), DT3 ( DP3 ) )                     => false

    }, {
        key: 'isSecurityClauseNeeded',
        value: function isSecurityClauseNeeded(node) {
            if (node instanceof _DocumentType2.default || node instanceof _DocumentTypeList2.default) {
                return false;
            }
            if (node.children.length === 0) {
                return true;
            }
            var hasDocTypePred = false,
                allDocTypePreds = true;

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(node.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var child = _step2.value;

                    if (child instanceof _DocumentType2.default || child instanceof _DocumentTypeList2.default) {
                        if (node instanceof _NotCondition2.default) {
                            return true;
                        }
                        hasDocTypePred = true;
                        continue;
                    }
                    allDocTypePreds = false;
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (allDocTypePreds) {
                return false;
            }
            if (hasDocTypePred && node instanceof _AndCondition2.default) {
                return false;
            }
            if (node instanceof _NotCondition2.default) {
                return true;
            }
            var allChildrenNotNeeded = true;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = (0, _getIterator3.default)(node.children), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var _child = _step3.value;

                    if (this.isSecurityClauseNeeded(_child)) {
                        allChildrenNotNeeded = false;
                    } else if (node instanceof _AndCondition2.default) {
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return !allChildrenNotNeeded;
        }
    }, {
        key: 'visitDocumentTypePredicate',
        value: function visitDocumentTypePredicate(context) {
            var documentTypeNode = (0, _lodash.get)(this.queryNode, context.path);
            var ancestorsOfTypeNotCondition = DocumentTypeSecurityOptimizerVisitor.getAncestorsOfTypes(documentTypeNode, [_NotCondition2.default.name], this.queryNode);
            if (ancestorsOfTypeNotCondition.length > 0) {
                return;
            }
            if (documentTypeNode.documentType && this.allowableDocumentTypes && !this.allowableDocumentTypes.includes(documentTypeNode.documentType.id)) {
                documentTypeNode.documentType = null;
            }
        }
    }, {
        key: 'visitDocumentTypeListPredicate',
        value: function visitDocumentTypeListPredicate(context) {
            var _this2 = this;

            var documentTypeListNode = (0, _lodash.get)(this.queryNode, context.path);
            var ancestorsOfTypeNotCondition = DocumentTypeSecurityOptimizerVisitor.getAncestorsOfTypes(documentTypeListNode, [_NotCondition2.default.name], this.queryNode);
            if (ancestorsOfTypeNotCondition.length > 0) {
                return;
            }
            if (this.allowableDocumentTypes) {
                documentTypeListNode.documentTypes = documentTypeListNode.documentTypes.filter(function (dt) {
                    return _this2.allowableDocumentTypes.includes(dt.id);
                });
            }
        }
    }], [{
        key: 'getDescendantsOfTypes',
        value: function getDescendantsOfTypes(node, types) {
            var descendants = [];
            if (types.includes(node.type)) {
                descendants.push(node);
            }
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(node.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var child = _step4.value;

                    var childDescendants = DocumentTypeSecurityOptimizerVisitor.getDescendantsOfTypes(child, types);
                    descendants.push.apply(descendants, (0, _toConsumableArray3.default)(childDescendants));
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return descendants;
        }
    }, {
        key: 'getAncestorsOfTypes',
        value: function getAncestorsOfTypes(node, types, stopParent) {
            var ancestors = [];
            if (!node || node === stopParent || node.isRootFolder) {
                return ancestors;
            }
            if (types.includes(node.type)) {
                ancestors.push(node);
            }
            var childAncestors = DocumentTypeSecurityOptimizerVisitor.getAncestorsOfTypes(node.parentNode, types, stopParent);
            ancestors.push.apply(ancestors, (0, _toConsumableArray3.default)(childAncestors));
            return ancestors;
        }
    }]);
    return DocumentTypeSecurityOptimizerVisitor;
}(_QueryNodeVisitor3.default);

exports.default = DocumentTypeSecurityOptimizerVisitor;